module.exports = __webpack_public_path__ + "img/about_us_header.23a2e26d.png";